import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import { useSelector } from "react-redux";

import * as layoutConstants from "../constants/layout";

// All layouts/containers
import DefaultLayout from "../layouts/Default";
import VerticalLayout from "../layouts/Vertical";
import DetachedLayout from "../layouts/Detached";
import HorizontalLayout from "../layouts/Horizontal/";
import { useDispatch } from "react-redux";
import { account } from "../redux/actions";
import {
  authProtectedFlattenRoutes,
  publicProtectedFlattenRoutes,
} from "./index";
import ErrorPageNotFoundAlt from "../pages/error/PageNotFoundAlt";
import { getUserFromSession } from "../helpers/api/apiCore";

const Routes = (props) => {
  const [host, setHost] = useState();
  const dispatch = useDispatch();
  const { layout, user, data } = useSelector((state) => ({
    layout: state.Layout,
    user: state.Auth.user,
    data: state.Invoice.data,
  }));

  useEffect(() => {
    // resetAuth()
    const domainName = window.location.hostname; //3f9603b6c2bf
    const hosti = domainName.split(".")[0];

    //console.log(hosti); // "reactgo.com"

    setHost(hosti);

    if (hosti) {
      dispatch(account(hosti));
    }
  }, []);

  const getLayout = () => {
    let layoutCls = VerticalLayout;

    switch (layout.layoutType) {
      case layoutConstants.LAYOUT_HORIZONTAL:
        layoutCls = HorizontalLayout;
        break;
      case layoutConstants.LAYOUT_DETACHED:
        layoutCls = DetachedLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  let Layout = getLayout();

  return (
    <BrowserRouter>
      <Switch>
        <Route path={publicProtectedFlattenRoutes.map((r) => r["path"])}>
          <DefaultLayout {...props} layout={layout}>
            <Switch>
              {publicProtectedFlattenRoutes.map((route, index) => {
                return (
                  !route.children && (
                    <route.route
                      key={index}
                      path={route.path}
                      roles={route.roles}
                      exact={route.exact}
                      component={route.component}
                    />
                  )
                );
              })}
            </Switch>
          </DefaultLayout>
        </Route>

        <Route path={authProtectedFlattenRoutes.map((r) => r["path"])}>
          <Layout {...props} layout={layout} user={user} data={data}>
            <Switch>
              {authProtectedFlattenRoutes.map((route, index) => {
                return (
                  !route.children && (
                    <route.route
                      key={index}
                      path={route.path}
                      roles={route.roles}
                      exact={route.exact}
                      component={route.component}
                    />
                  )
                );
              })}

              <Route component={ErrorPageNotFoundAlt}>
                {!user && <Redirect to="/error-404-alt" />}
              </Route>
            </Switch>
          </Layout>
        </Route>

        {/* <Route path="" element={<Redirect to="/error-404-alt" />} /> */}
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
